import React from 'react'

import { NOOP } from 'constants/commonConstans'
import { BrandFormEnum } from 'services/Branding/types'

import SliderFormFont from './SliderFormFont'
import SliderFormStyle from './SliderFormStyle'
import type { SliderFormBrandType, SliderBrandForms } from './sliderTypes'

const FORM_MAP: SliderBrandForms = {
  [BrandFormEnum.STYLE]: SliderFormStyle,
  base: SliderFormFont,
}

const SliderFormBrand: SliderFormBrandType = (props) => {
  const Form = FORM_MAP[props.form] || NOOP
  return <Form {...props} />
}

export default React.memo(SliderFormBrand) as typeof SliderFormBrand
